import { Component, OnInit } from '@angular/core';
import { MenuItem, MenuItemRoute } from '@enums/menu-item.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  styles: [`
  >>> app-report {
    display: flex;
    height: 100%;
    margin: auto;
  }
`]
})
export class ReportComponent implements OnInit {

 
  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit() {
   
  }

}
